/** Formats a number with thousands separators, identically on server and client. */
export const formatNumber = (value: number, decimals = 0): string => {
    const [whole, fraction] = value.toFixed(decimals).split('.')
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return fraction ? `${grouped}.${fraction}` : grouped
}

/** Two-digit hole and index numbers: 1 becomes 01. */
export const pad = (value: number, length = 2): string => String(value).padStart(length, '0')
